import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'classTypePipe'
})
export class ClassTypePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.map((x)=>{
        if(x.Value==1)return "Class 1";
        if(x.Value==2)return "Class 2";
        else return "Class 3";
    })
  }

}
